import * as React from 'react'
import * as Styled from './SVGImage/SVGImage.styles'

const SVGImage = ({ url, description, svg, presentationWidth, ...props }) => {
  if (!svg && !url) return null

  return svg ? (
    <Styled.SVGWrapper
      className="svg-image"
      maxWidth={`${presentationWidth}px`}
      // We know that svg data comes from within the company through a CMS entry
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
      {...props}
    />
  ) : (
    <img src={url} alt={description} />
  )
}

export default SVGImage
